import { FAQItem, GameConfiguration } from './types';
import { vinhosModuleFaqItems } from './moduleContent';
import { reserve2010FaqItems } from './reserve-2010';
import { filterByConfiguration } from './contentFilter';

const vinhosFaqItemsBase: FAQItem[] = [
  {
    id: 'same-action-twice',
    question: 'Czy mogę wykonać tę samą akcję dwa razy w jednym roku?',
    answer:
      'Tak, jeżeli po pierwszej akcji opuścisz jej pole, a przy drugiej akcji legalnie na nie wrócisz. Nie możesz po prostu pozostać na tym samym polu Quadrelu.',
    tags: ['akcje', 'quadrel'],
    chapterId: 'main-actions',
    group: 'Akcje i Quadrel',
  },
  {
    id: 'stay',
    question: 'Czy mogę zostać na tym samym polu Quadrelu?',
    answer:
      'Zasadniczo nie. Musisz się przemieścić. Wyjątek dotyczy pola Pass / Press Release, gdy już tam jesteś i nie możesz wykonać innej legalnej akcji.',
    tags: ['akcje', 'ruch'],
    chapterId: 'main-actions',
    group: 'Akcje i Quadrel',
  },
  {
    id: 'movement-cost',
    question: 'Za co płacę podczas ruchu?',
    answer:
      '1 bago za ruch na pole niesąsiadujące, po 1 bago każdemu graczowi już stojącemu na polu docelowym oraz 1 bago do banku, jeżeli leży tam znacznik roku/podatku. Wejście na Pass / Press Release jest bezpłatne.',
    tags: ['ruch', 'pieniądze'],
    chapterId: 'main-actions',
    group: 'Akcje i Quadrel',
  },
  {
    id: 'wine-value',
    question: 'Kiedy wino zwiększa wartość?',
    answer:
      'Podczas fazy starzenia na końcu roku, gdy przesuwasz je o jedno pole w prawo. Piwnica daje dłuższy tor dojrzewania niż zwykły magazyn.',
    tags: ['wino', 'piwnice'],
    chapterId: 'cellars-aging',
    group: 'Wino i produkcja',
  },
  {
    id: 'aging-order',
    question: 'Najpierw starzenie czy produkcja?',
    answer:
      'Najpierw przesuwasz istniejące wina o jedno pole w prawo, a dopiero potem produkujesz nowe wina i kładziesz je na lewym polu magazynu albo piwnicy.',
    tags: ['wino', 'produkcja'],
    chapterId: 'wine-production',
    group: 'Wino i produkcja',
  },
  {
    id: 'unsold-wine',
    question: 'Co dzieje się z niesprzedanym winem?',
    answer:
      'Pozostaje w magazynie lub piwnicy i może dalej dojrzewać. Nie musisz sprzedawać go w roku produkcji.',
    tags: ['wino', 'sprzedaż'],
    chapterId: 'bank-money',
    group: 'Wino i produkcja',
  },
  {
    id: 'export',
    question: 'Jak działa eksport?',
    answer:
      'Wybierasz wino spełniające wymaganie wolnego pola eksportu, odrzucasz wino, umieszczasz swoją beczkę na polu i otrzymujesz wskazane VP. Dostępne pola zależą od liczby graczy.',
    tags: ['eksport'],
    chapterId: 'export',
    group: 'Sprzedaż i eksport',
  },
  {
    id: 'renown',
    question: 'Czy renoma regionu stale zwiększa wartość wina?',
    answer:
      'Nie. Renoma jest wydawana lub używana tylko w sytuacjach dozwolonych przez konkretną akcję, np. przy spełnianiu progu sprzedaży, eksportu albo podczas deklaracji targowej.',
    tags: ['renoma', 'regiony'],
    chapterId: 'key-concepts',
    group: 'Sprzedaż i eksport',
  },
  {
    id: 'wine-fairs',
    question: 'Kiedy odbywają się targi?',
    answer:
      'Po 3., 5. i 6. roku. Każdy gracz musi wystawić dokładnie jedno wino na każdy targ.',
    tags: ['targi'],
    chapterId: 'wine-fairs',
    group: 'Targi',
  },
  {
    id: 'press-release',
    question: 'Po co ogłaszać wino przed targami?',
    answer:
      'Wcześniejszy Press Release pozwala wcześniej zająć stanowisko targowe i skorzystać z magnatów. Minusem jest deklarowanie wina, zanim zdąży bardziej dojrzeć.',
    tags: ['targi', 'press release'],
    chapterId: 'wine-fairs',
    group: 'Targi',
  },
  {
    id: 'sales-maintenance',
    question: 'Ile beczek zabieram ze sprzedaży podczas utrzymania?',
    answer:
      'Dokładnie jedną własną beczkę, jeżeli masz przynajmniej jedną na rynku sprzedaży. Nie zabierasz wszystkich.',
    tags: ['sprzedaż', 'utrzymanie'],
    chapterId: 'end-of-year',
    group: 'Sprzedaż i eksport',
  },
  {
    id: 'experts-refresh',
    question: 'Kiedy odświeżają się eksperci?',
    answer:
      'Przed rozpoczęciem 4. i 6. roku odwracasz swoje zakryte kafle ekspertów i kafle akcji magnatów odkryte. Odrzucone kafle nie wracają w ten sposób.',
    tags: ['eksperci'],
    chapterId: 'experts',
    group: 'Eksperci i warianty',
  },
  {
    id: 'multiple-vineyards',
    question: 'Czy mogę mieć kilka winnic w jednym regionie?',
    answer:
      'Tak, o ile limity posiadłości i miejsca na planszy gracza na to pozwalają. Winnice z tego samego regionu należą do tej samej posiadłości.',
    tags: ['winnice', 'regiony'],
    chapterId: 'vineyards-regions',
    group: 'Wino i produkcja',
  },
  {
    id: 'money-points',
    question: 'Czy 1 bago to 1 punkt?',
    answer:
      'Nie. Pieniądze i VP to oddzielne zasoby. Na końcu gry stosujesz wyłącznie przelicznik pokazany w zasadach lub na planszy.',
    tags: ['pieniądze', 'punktacja'],
    chapterId: 'final-scoring',
    group: 'Punktacja',
  },
  {
    id: 'edition-difference',
    question: 'Czym różni się Special Vintage 2016 od Reserve 2010?',
    answer:
      '2016 jest przebudowaną, mniej zawiłą wersją z tym samym rdzeniem. Reserve 2010 zachowuje cięższy system oryginalnej gry (bank, cechy targów, magnaci). Nie mieszaj szczegółów obu wariantów — w aplikacji każda wersja ma pełną, osobną treść.',
    tags: ['warianty'],
    chapterId: 'before-you-start',
    group: 'Eksperci i warianty',
  },
  {
    id: 'combine-modules',
    question: 'Czy moduły można łączyć?',
    answer:
      'Tak. Experts, Islands, Tasting Room i Connoisseur można łączyć dowolnie. Stosuj interakcje: turysta z Madery korzysta z reguł turystów; turysta nie może wejść do podwójnej piwnicy. Na pierwszą partię graj bez modułów.',
    tags: ['moduły'],
    chapterId: 'before-you-start',
    group: 'Eksperci i warianty',
  },
  ...vinhosModuleFaqItems.map((item) => ({
    ...item,
    group: item.group ?? 'Moduły',
  })),
]
  .map(
    (item): FAQItem =>
      item.requiredVariantIds?.length
        ? item
        : { ...item, requiredVariantIds: ['special-vintage-2016'] }
  );

export const vinhosFaqItems: FAQItem[] = [
  ...vinhosFaqItemsBase,
  ...reserve2010FaqItems,
];


export function filterFaqForModules(
  items: FAQItem[],
  activeModuleIds: string[]
): FAQItem[] {
  return items.filter(
    (i) =>
      !i.requiredModuleIds?.length ||
      i.requiredModuleIds.every((id) => activeModuleIds.includes(id))
  );
}

export function filterFaqForConfiguration(
  config: GameConfiguration,
  items: FAQItem[] = vinhosFaqItems
): FAQItem[] {
  return filterByConfiguration(items, config);
}

export function filterFaqItems(
  query: string,
  items: FAQItem[] = vinhosFaqItems
): FAQItem[] {
  const n = query.trim().toLocaleLowerCase('pl');
  if (!n) return items;
  return items.filter((i) =>
    `${i.question} ${i.answer} ${i.tags?.join(' ') ?? ''} ${i.group ?? ''}`
      .toLocaleLowerCase('pl')
      .includes(n)
  );
}

export function groupFaqItems(
  items: FAQItem[]
): { group: string; items: FAQItem[] }[] {
  const order: string[] = [];
  const map = new Map<string, FAQItem[]>();
  for (const item of items) {
    const group = item.group ?? 'Inne';
    if (!map.has(group)) {
      order.push(group);
      map.set(group, []);
    }
    map.get(group)!.push(item);
  }
  return order.map((group) => ({ group, items: map.get(group)! }));
}
